import axios from "axios"
import API_URLS from "../../config/global_variables";
import common_mapping from "../../config/common_mapping";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";

const initialData = Array.from({ length: 50 }, (_, index) => {
  const key = (index + 1).toString();
  return {
    key,
    kitname: "",
    sapCustomerNumber: index % 2 === 0 ? "US" : "UK",
    sapPrice: "$45",
    sapMsrp: "$45",
    bcSku: `BC123${index}`,
    enrichment: index % 5 !== 0, // every 5th is false
    lastUpdated: "22-10-2024, 14:33:11",
    action: index % 10 === 2 ? "create" : "Edit",
  };
});

const apidata = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_KIT_PRODUCTS,
      headers: {
        'Content-Type': 'application/json', 'Authorization': userData.token
      },
    };

    let data = await axios.request(config)
    if (data.status === 200) {
      const mappedData = common_mapping.map_kitList(data.data.result)
      return mappedData
    }
    return [];
  } catch (error) {
    console.error("error", error);

    return [];
  }
}
const get_stores = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_STORES,
      headers: {
        'Content-Type': 'application/json', 'Authorization': userData.token
      },
    };

    let data = await axios.request(config)
    if (data.status === 200) {
      const mappedData = data.data.data.map((item, index) => {
        let properties = JSON.parse(item.properties)
        return {
          value: properties.key,
          label: properties.key
        }
      })
      return mappedData
    }
    return [];

  } catch (error) {
    return [];
  }
}
const active_inactive_status = async (reqdata = {}, status) => {
  try {

    if (reqdata && reqdata.prod_id) {
      let objdata = {}
      objdata = {
        "store": reqdata.store,
        "product_id": reqdata.prod_id,
        "status": status,
        "is_variant": false
      }
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URLS.UPDATE_BC_PRODUCT_STATUS,
        headers: {
          'Content-Type': 'application/json', 'Authorization': userData.token
        },
        data: JSON.stringify(objdata)
      };

      let data = await axios.request(config)
      if (data.status === 200) {
        return data
      }
      return false;
    } else {
      return false;
    }

  } catch (error) {
    return false;
  }
}
const apiService = { initialData, apidata, get_stores, active_inactive_status };

export default apiService;
